import { Component, inject, input, viewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

import { AdaaHelper } from "../../../core/utils";
import { ConfirmationModalComponent, DataTableComponent } from "../../../shared/components";
import { genericFloatButtons } from "../../../shared/components/general/float-action";
import { Constants } from "../../../shared/constants/constants";
import { Language } from "../../../shared/constants/enums";
import { TableButtonClicked } from "../../../shared/models";
import { AppService, SystemLayoutService } from "../../../shared/services";
import { TextMappingsApiService } from "../../../shared/services/text-mapping-api-service";

@Component({
  selector: "adaa-text-mappings-list",
  imports: [DataTableComponent],
  templateUrl: "./text-mappings-list.html",
  styleUrl: "./text-mappings-list.scss",
})
export class TextMappingsListComponent {
  private _router = inject(Router);
  private _modalService = inject(NgbModal);
  private _appService = inject(AppService);
  private _toastrService = inject(ToastrService);
  private _translateService = inject(TranslateService);
  private _textMappingsApiService = inject(TextMappingsApiService);
  private readonly _systemLayoutService = inject(SystemLayoutService);

  tableConfList = input.required<string>();
  adaaDataTable = viewChild.required<DataTableComponent>("adaaDataTable");
  constants = Constants;

  readonly #floatActions = genericFloatButtons();
  readonly #untilDestroy = AdaaHelper.untilDestroyed();

  public ngOnInit() {
    this.#floatActions([
      {
        key: "print",
        data: undefined,
      },
      {
        key: "helpdesk",
        data: {
          url: "/helpdesk/create",
        },
      },
    ]);
    this._refreshPage();
  }
  private _refreshPage() {
    this._systemLayoutService.hasActiveEntityChanged$.pipe(this.#untilDestroy()).subscribe({
      next: () => {
        this._router.navigateByUrl("/console");
      },
    });
  }
  public addNewClicked() {
    this._router.navigateByUrl(`/console/text-mapping/create`);
  }

  public getAction(event: TableButtonClicked) {
    const textMappingId = event.data.id;
    switch (event.event) {
      case "view":
        this._router.navigateByUrl(`/console/text-mapping/${textMappingId}`);
        break;
      case "edit":
        this._router.navigateByUrl(`/console/text-mapping/edit/${textMappingId}`);
        break;
      case "delete":
        this._deleteTextMapping(textMappingId);
        break;

      default:
        break;
    }
  }

  private _deleteTextMapping(textMappingId: number) {
    const modal = this._modalService.open(ConfirmationModalComponent, {
      centered: true,
      size: "md",
      modalDialogClass: this._appService.language() === Language.Arabic ? "modal-rtl" : "modal-ltr",
    });

    modal.componentInstance.header = "text_mappings.delete_confirmation";
    modal.componentInstance.title = "text_mappings.delete_message";

    modal.result.then((e) => {
      if (e) {
        this._textMappingsApiService.deleteTextMapping(textMappingId).subscribe({
          next: (response) => {
            if (response.inError) return;
            this._toastrService.success(this._translateService.instant("notification.success.remove"));
            this.adaaDataTable().loadTableData();
          },
        });
      }
    });
  }
}
